import { useState, useContext, useEffect } from "react"
import { gql, useLazyQuery } from "@apollo/client"
import { LoaderMedium } from "../../Loaders"
import _ from "lodash"

import { Field, useFormikContext } from "formik"

import { Checkbox } from "primereact/checkbox"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"
export default function CheckboxEnterpriseFeatures({ field, block, index }) {
  const [featuresList, setFeaturesList] = useState([])
  const [visible] = useState("block")

  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_FEATURES = gql`
    query getFeatures(
      $staff_id: ID!
      $staff_organization_id: ID!
      $organization_id: ID!
    ) {
      features: getFeatures(
        staff_id: $staff_id
        staff_organization_id: $staff_organization_id
        organization_id: $organization_id
        features_status: "ACTIVE"
      ) {
        features_id
        features_name
        features_alias
        features_description
        features_fee_amount
        __typename
      }
    }
  `

  const [getFeatures, { loading }] = useLazyQuery(GET_FEATURES, {
    fetchPolicy: "no-cache",
    onCompleted: ({ features }) => {
      setFeaturesList(features)
    },
    skip: !userCtx,
  })

  useEffect(() => {
    if (form?.editMode) {
      return getFeatures({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          staff_organization_id: userCtx.session.user.organization_id,
          organization_id: userCtx.session.user.enterprise_id,
        },
      })
    } else {
      return getFeatures({
        variables: {
          staff_id: userCtx.session.user.staff_id,
          staff_organization_id: userCtx.session.user.organization_id,
          organization_id: "",
        },
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div>
        <LoaderMedium />
      </div>
    )
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      {featuresList.map((feature, index) => {
        const field_name = `features_${_.replace(
          _.lowerCase(feature.features_name),
          / /g,
          "_"
        )}`

        return (
          <div key={index} onBlur={() => formik.setFieldTouched(field_name)}>
            <Field name={field_name}>
              {({ field: formikField, meta, form }) => {
                const handleCheckboxChange = (e) => {
                  let currentValue = formikField.value || [] // Ensure it's an array

                  if (!Array.isArray(currentValue)) {
                    currentValue = [] // Fallback to an empty array if necessary
                  }

                  const isChecked = _.includes(
                    currentValue,
                    feature.features_id
                  )

                  if (!isChecked) {
                    confirmDialog({
                      message: (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: `Two Factor Authentication requires all staff members to have a phone capable of receiving SMS messages or an authenticator app to retrieve one time authorization codes.<br>Please note that once enabled, a <strong>2-week compliance period</strong> will be provided to all staff members within the Enterprise. <br><br> 
                        <span style="color: red;">Exceptions to the Two-Factor Authentication requirement will not be possible with this feature enabled.</span> <br><br> 
                        In order to remove this requirement following the compliance period, Two-Factor Authentication must be turned off by the enterprise administrator.`,
                          }}
                        />
                      ),
                      header: "Confirmation",
                      icon: "pi pi-exclamation-triangle",
                      accept: () => {
                        form.setFieldValue(field_name, [
                          ...currentValue,
                          feature.features_id,
                        ])
                      },
                      reject: () => {},
                    })
                  } else {
                    // Directly update state for deactivation
                    const newValue = currentValue.filter(
                      (id) => id !== feature.features_id
                    )
                    form.setFieldValue(field_name, newValue)
                  }
                }

                return (
                  <div
                    className={styles.field}
                    style={{
                      order: index,
                      display: visible,
                    }}
                  >
                    <ConfirmDialog />{" "}
                    {/* Include this component at least once in your JSX tree */}
                    <Checkbox
                      disabled={isDisabled}
                      inputId={field_name}
                      name={field_name}
                      id={field_name}
                      value={feature.features_id}
                      onChange={handleCheckboxChange}
                      checked={_.includes(
                        formikField.value,
                        feature.features_id
                      )}
                    />
                    <label
                      htmlFor={field_name}
                      style={{ marginLeft: 5, fontWeight: "bold" }}
                    >
                      {feature.features_alias}
                    </label>
                    {feature.features_description && (
                      <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                          __html: feature.features_description,
                        }}
                      />
                    )}
                    {feature.features_fee_amount && (
                      <p
                        style={{ marginLeft: 5, fontStyle: "italic" }}
                        className={styles.description}
                        dangerouslySetInnerHTML={{
                          __html: feature.features_fee_amount,
                        }}
                      />
                    )}
                  </div>
                )
              }}
            </Field>
          </div>
        )
      })}
    </div>
  )
}
